export default {
    state: {
        cupom: {},
    },
};
